export function i18nCounterString(i18nString, current, total) {
  if (total === undefined) return i18nString.replace(/(%current)/g, current.toString());
  return i18nString.replace(/(%current)/g, current.toString()).replace(/(%total)/g, total.toString());
}